export default __webpack_public_path__ + "static/media/api-testing.b3bf657d.svg";